import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase'; // Adjust the path if needed
import { collection, getDocs, setDoc, doc, Timestamp } from 'firebase/firestore';
import './News.css'; // Import a CSS file for styling

const News = () => {
  const [newsList, setNewsList] = useState([]);
  const [formData, setFormData] = useState({
    id: '', // Added ID field
    title: '',
    description: '',
    image: '',
    link: '',
    date: '', // Added date field
  });

  // Function to fetch news from Firestore
  const fetchNews = async () => {
    const newsCollectionRef = collection(db, 'news'); // Adjust the collection name as needed
    const newsSnapshot = await getDocs(newsCollectionRef);
    const newsData = newsSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setNewsList(newsData);
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddNews = async (e) => {
    e.preventDefault(); // Prevent page refresh
    const newsDocRef = doc(db, 'news', formData.id); // Create a reference with the custom ID

    // Convert date to Firestore timestamp format
    const timestamp = Timestamp.fromDate(new Date(formData.date));

    await setDoc(newsDocRef, {
      title: formData.title,
      description: formData.description,
      image: formData.image,
      link: formData.link,
      date: timestamp, // Store the date in Firestore format
    });

    // Clear the form
    setFormData({ id: '', title: '', description: '', image: '', link: '', date: '' });
    fetchNews(); // Refresh the news list
  };

  return (
    <div className="news-container">
      <h2>News List</h2>
      <div className="news-grid">
        {newsList.map((news) => (
          <div className="news-card" key={news.id}>
            <Link to={`/news/${news.id}`} className="news-link">
              <img src={news.image} alt={news.title} className="news-image" />
              <h3>{news.title}</h3>
              <p>{news.description.slice(0, 100)}...</p> {/* Preview of the description */}
              {/* Display the date if it exists */}
              <p className="news-date">
                {news.date && news.date.seconds
                  ? new Date(news.date.seconds * 1000).toLocaleDateString()
                  : 'No Date Available'}
              </p>
            </Link>
          </div>
        ))}
      </div>

      <h2>Add New News</h2>
      <form onSubmit={handleAddNews} className="news-form">
        <input
          type="text"
          name="id"
          value={formData.id}
          onChange={handleInputChange}
          placeholder="Document ID"
          required
          className="news-input"
        />
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleInputChange}
          placeholder="Title"
          required
          className="news-input"
        />
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleInputChange}
          className="news-input"
        />
        <textarea
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          placeholder="Description"
          required
          className="news-textarea"
        />
        <input
          type="text"
          name="image"
          value={formData.image}
          onChange={handleInputChange}
          placeholder="Image URL"
          required
          className="news-input"
        />
        <input
          type="text"
          name="link"
          value={formData.link}
          onChange={handleInputChange}
          placeholder="Link URL"
          required
          className="news-input"
        />
    
        <button type="submit" className="add-news-button">Add News</button>
      </form>
    </div>
  );
};

export default News;
